import React from 'react';
import { SettingsManager, useSettings } from '@atlas/core';

export default function useThemeBootstrap() {
  const { theme } = useSettings();

  React.useEffect(() => {
    if (!theme) {
      SettingsManager.updateSettings({ theme: SYS_CONFIG.defaultTheme });
      return;
    }

    document.documentElement.setAttribute('theme', theme);
  }, [theme]);
}
